<template>
  <div class="propject_detail_info col-1 scroll flex-row">
    <div class="col-1">
      <!-- <div class="flex-row justify-between"></div> -->

      <!-- 岗位要求 -->
      <el-card
        :class="[changeFields.includes('岗位要求') ? 'edit-background-color' : '', 'propject_detail_info_block']"
      >
        <div v-if="changeFields.includes('岗位要求')" class="propject_detail_info_block_handlers">
          <a class="mr5" @click="cancelEdit('岗位要求')">取消</a> <a @click="updateProjectInner('岗位要求')">保存</a>
        </div>
        <span v-else class="el-icon-edit-outline" @click="editProjectField('岗位要求')">编辑</span>
        <p class="propject_detail_info_title">
          岗位要求{{ project['岗位要求'] ? '' : '（暂无数据）' }}
          <a @click="upload('岗位要求')"> <i class="el-icon-circle-plus" /> </a>
        </p>
        <el-input
          v-if="changeFields.includes('岗位要求')"
          v-model="changes['岗位要求']"
          type="textarea"
          size="mini"
          autosize
          :rows="5"
          :placeholder="
            `案例：\n1. 学历：重点院校本科或硕士以上，MBA优先；\n2. 专业：金融、经济、管理或理工类专业,具备经济和理工科复合教育背景优先；\n3. 3年以上VC/PE/IB或者互联网企业战投相关工作经验，对泛互联网、TMT领域有深入行业洞见；\n4. 英语读写熟练，有一定的口语交流能力。`
          "
        />
        <pre v-else-if="project['岗位要求']" ref="岗位要求">{{ project['岗位要求'] }}</pre>
        <!-- <el-link
          v-if="!changeFields.includes('岗位要求') && isHiddenBtnShow['岗位要求']"
          type="primary"
          :underline="false"
          :icon="isHidden['岗位要求'] ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          style="cursor:pointer;position:absolute;bottom:20px;right:20px"
          @click="toggleHide('岗位要求')"
          >{{ isHidden['岗位要求'] ? '展开' : '收起' }}</el-link
        > -->
      </el-card>

      <!-- 核心要求 -->
      <el-card
        :class="[changeFields.includes('核心要求') ? 'edit-background-color' : '', 'propject_detail_info_block']"
      >
        <div v-if="changeFields.includes('核心要求')" class="propject_detail_info_block_handlers">
          <a class="mr5" @click="cancelEdit('核心要求')">取消</a> <a @click="updateProjectInner('核心要求')">保存</a>
        </div>
        <span v-else class="el-icon-edit-outline" @click="editProjectField('核心要求')">编辑</span>
        <p class="propject_detail_info_title">
          核心要求{{ project['核心要求'] ? '' : '（暂无数据）' }}
          <a @click="upload('核心要求')"> <i class="el-icon-circle-plus" /> </a>
        </p>
        <el-input
          v-if="changeFields.includes('核心要求')"
          v-model="changes['核心要求']"
          type="textarea"
          :rows="5"
          :placeholder="`请填写客户提出的必须满足的核心要求`"
        />
        <pre v-else-if="project['核心要求']" ref="核心要求">{{ project['核心要求'] }}</pre>
        <!-- <el-link
          v-if="!changeFields.includes('核心要求') && isHiddenBtnShow['核心要求']"
          type="primary"
          :underline="false"
          :icon="isHidden['核心要求'] ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          style="cursor:pointer;position:absolute;bottom:20px;right:20px"
          @click="toggleHide('核心要求')"
          >{{ isHidden['核心要求'] ? '展开' : '收起' }}</el-link
        > -->
      </el-card>

      <!-- 岗位职责 -->
      <el-card
        :class="[changeFields.includes('岗位职责') ? 'edit-background-color' : '', 'propject_detail_info_block']"
      >
        <div v-if="changeFields.includes('岗位职责')" class="propject_detail_info_block_handlers">
          <a class="mr5" @click="cancelEdit('岗位职责')">取消</a> <a @click="updateProjectInner('岗位职责')">保存</a>
        </div>
        <span v-else class="el-icon-edit-outline" @click="editProjectField('岗位职责')">编辑</span>
        <p class="propject_detail_info_title">
          岗位职责{{ project['岗位职责'] ? '' : '（暂无数据）' }}
          <a @click="upload('岗位职责')"> <i class="el-icon-circle-plus" /> </a>
        </p>
        <el-input
          v-if="changeFields.includes('岗位职责')"
          v-model="changes['岗位职责']"
          type="textarea"
          autosize
          :rows="5"
          :placeholder="
            `案例：\n1. 独立寻找和筛选有发展潜力和投资价值的项目机会；\n2. 独立进行市场和行业研究；\n3. 独立构建项目财务模型，进行估值和回报分析；\n4. 协调外部资源实施项目尽职调查，出具尽职调查报告；`
          "
        />
        <pre v-else-if="project['岗位职责']" ref="岗位职责">{{ project['岗位职责'] }}</pre>
        <!-- <el-link
          v-if="!changeFields.includes('岗位职责') && isHiddenBtnShow['岗位职责']"
          type="primary"
          :underline="false"
          :icon="isHidden['岗位职责'] ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          style="cursor:pointer;position:absolute;bottom:20px;right:20px"
          @click="toggleHide('岗位职责')"
          >{{ isHidden['岗位职责'] ? '展开' : '收起' }}</el-link
        > -->
      </el-card>

      <!-- 部门详情 -->
      <el-card
        style="position:relative"
        :class="[changeFields.includes('部门详情') ? 'edit-background-color' : '', 'propject_detail_info_block']"
      >
        <div v-if="changeFields.includes('部门详情')" class="propject_detail_info_block_handlers">
          <a class="mr5" @click="cancelEdit('部门详情')">取消</a> <a @click="updateProjectInner('部门详情')">保存</a>
        </div>
        <span v-else class="el-icon-edit-outline" @click="editProjectField('部门详情')">编辑</span>
        <div class="title" style="position:static;padding-top:0;padding-right:0">
          <div class="name">部门详情</div>
          <!-- <div class="handel-btn">
            <el-link
              v-if="!changeFields.includes('部门详情')"
              :underline="false"
              type="primary"
              style="margin-left:10px"
              @click="editProjectField('部门详情')"
              >编辑</el-link
            >
            <div v-else>
              <el-link :underline="false" type="primary" style="margin-left:10px" @click="cancelEdit('部门详情')"
                >取消</el-link
              >
              <el-link
                :underline="false"
                type="primary"
                style="margin-left:10px"
                @click="updateProjectInner('部门详情')"
                >保存</el-link
              >
            </div>
          </div> -->
        </div>
        <div v-if="!changeFields.includes('部门详情')">
          <div class="content">
            <!-- <p class="propject_detail_info_label">部门详情</p> -->
            <pre>{{ project['部门详情'] }}</pre>
          </div>
        </div>
        <div v-else>
          <!-- <p class="propject_detail_info_label">部门详情</p> -->
          <el-input v-if="changeFields.includes('部门详情')" v-model="changes['部门详情']" type="textarea" autosize />
        </div>
      </el-card>

      <!-- 寻访方向 -->
      <el-card
        :class="[changeFields.includes('寻访方向') ? 'edit-background-color' : '', 'propject_detail_info_block']"
      >
        <div v-if="xunfangIsEditing" class="propject_detail_info_block_handlers">
          <a class="mr5" @click="cancelXunfang">取消</a> <a @click="saveXunfang">保存</a>
        </div>
        <span v-else class="el-icon-edit-outline" @click="editXunfang">编辑</span>
        <p class="propject_detail_info_title">寻访方向{{ project['寻访方向'] ? '' : '（暂无数据）' }}</p>
        <el-input
          v-if="changeFields.includes('寻访方向')"
          v-model="changes['寻访方向']"
          type="textarea"
          :rows="5"
          :placeholder="`请填写客户或顾问提出的，人才搜寻方向`"
        />
        <pre v-else-if="project['寻访方向']" ref="寻访方向">{{ project['寻访方向'] }}</pre>
        <!-- <el-link
          v-if="!changeFields.includes('寻访方向') && isHiddenBtnShow['寻访方向']"
          type="primary"
          :underline="false"
          :icon="isHidden['寻访方向'] ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          style="cursor:pointer;position:absolute;bottom:20px;right:20px"
          @click="toggleHide('寻访方向')"
          >{{ isHidden['寻访方向'] ? '展开' : '收起' }}</el-link
        > -->
        <el-row :gutter="24">
          <el-col :span="24">
            <div>
              <p class="propject_detail_info_label">
                目标公司 <a @click="selectCompany"> <i class="el-icon-circle-plus" /> </a>
              </p>
              <div v-if="changeFields.includes('目标公司备注')">
                <el-input v-model="changes['目标公司备注']" placeholder="目标公司" type="textarea" autosize />
              </div>
              <div v-else-if="project['目标公司备注']" class="pd10">{{ project['目标公司备注'] }}</div>
              <div class="flex-row flex-wrap">
                <a v-for="(value, i) in project['目标公司']" :key="i" class="label_tag" @click="showCompany(value)">
                  {{ value }}
                </a>
              </div>
            </div>
            <div style="margin-top:10px;">
              <p class="propject_detail_info_label">
                不倾向公司 <a @click="selectCompany1"> <i class="el-icon-circle-plus" /> </a>
              </p>
              <div v-if="changeFields.includes('不倾向公司备注')">
                <el-input v-model="changes['不倾向公司备注']" placeholder="不倾向公司" type="textarea" autosize />
              </div>
              <div v-else-if="project['不倾向公司备注']" class="pd10">{{ project['不倾向公司备注'] }}</div>
              <div class="flex-row flex-wrap">
                <a v-for="(value, i) in project['不倾向公司']" :key="i" class="label_tag" @click="showCompany(value)">
                  {{ value }}
                </a>
              </div>
            </div>
            <div style="margin-top:10px;">
              <p class="propject_detail_info_label">勿推荐公司(来源:公司)：</p>
              <el-tag v-for="item in company.勿推荐公司" :key="item" class="mr4 md4" size="mini" type="danger">{{
                item
              }}</el-tag>
            </div>
            <div style="margin-top:10px;">
              <p class="propject_detail_info_label">
                目标人选 <a @click="editProjectTargetRadishes"> <i class="el-icon-circle-plus" /> </a>
              </p>
              <div>
                <el-input
                  v-if="changeFields.includes('目标人选备注')"
                  v-model="changes['目标人选备注']"
                  placeholder="目标人选"
                  type="textarea"
                  autosize
                />
              </div>
              <div v-if="project['目标人选备注']" class="pd10">{{ project['目标人选备注'] }}</div>
              <div class="flex-row flex-wrap">
                <a
                  v-for="(value, i) in project['目标人选']"
                  :key="i"
                  class="label_tag"
                  @click="showRadishDetail({ _id: value.rid, 姓名: value.name })"
                  >{{ value.name }}</a
                >
              </div>
            </div>
            <div style="margin-top:10px;">
              <p class="propject_detail_info_label">阿尔法认知：</p>
              <el-input
                v-if="changeFields.includes('阿尔法认知')"
                v-model="changes['阿尔法认知']"
                placeholder="阿尔法认知"
                type="textarea"
                autosize
              />
              <pre v-else>{{ project['阿尔法认知'] }}</pre>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <!-- 职位亮点及优势 -->
      <el-card :class="[HightLightIsEditing ? 'edit-background-color' : '', 'propject_detail_info_block']">
        <div v-if="HightLightIsEditing" class="propject_detail_info_block_handlers">
          <a class="mr5" @click="cancelHightLight">取消</a> <a @click="saveHightLight">保存</a>
        </div>

        <span v-else class="el-icon-edit-outline" @click="editHightLight">编辑</span>
        <p class="propject_detail_info_title">
          职位亮点及优势{{ project['公司亮点及优势'] || project['项目亮点及优势'] ? '' : '（暂无数据）' }}
        </p>
        <div>
          <div
            v-if="project['公司亮点及优势'] || !isHidden['职位亮点及优势'] || changeFields.includes('公司亮点及优势')"
            style="font-size:14px;margin:20px 0;font-weight:600"
          >
            公司亮点及优势
          </div>
          <el-input
            v-if="changeFields.includes('公司亮点及优势')"
            v-model="changes['公司亮点及优势']"
            type="textarea"
            autosize
            placeholder="请输入公司亮点及优势"
          />
          <pre v-else-if="project['公司亮点及优势']" ref="公司亮点及优势">{{ project['公司亮点及优势'] }}</pre>
        </div>
        <div
          v-if="
            !isHidden['职位亮点及优势'] ||
              changeFields.includes('项目亮点及优势') ||
              (!project['公司亮点及优势'] && project['项目亮点及优势'])
          "
        >
          <div style="font-size:14px;margin:20px 0;font-weight:600">项目亮点及优势</div>
          <el-input
            v-if="changeFields.includes('项目亮点及优势')"
            v-model="changes['项目亮点及优势']"
            type="textarea"
            autosize
            placeholder="请输入项目亮点及优势"
          />
          <pre v-else-if="project['项目亮点及优势']">{{ project['项目亮点及优势'] }}</pre>
        </div>
        <div>
          <div style="font-size:14px;margin:20px 0;font-weight:600">职位劣势及风险点</div>
          <el-input
            v-if="changeFields.includes('职位劣势及风险点')"
            v-model="changes['职位劣势及风险点']"
            type="textarea"
            autosize
            placeholder="请输入职位劣势及风险点"
          />
          <pre v-else-if="project['职位劣势及风险点']">{{ project['职位劣势及风险点'] }}</pre>
        </div>
        <!-- <el-link
          v-if="
            !changeFields.includes('公司亮点及优势') &&
              !changeFields.includes('项目亮点及优势') &&
              (project['公司亮点及优势'] || project['项目亮点及优势'])
          "
          type="primary"
          :underline="false"
          :icon="isHidden['职位亮点及优势'] ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          style="cursor:pointer;position:absolute;bottom:20px;right:20px"
          @click="toggleHide('职位亮点及优势')"
          >{{ isHidden['职位亮点及优势'] ? '展开' : '收起' }}</el-link
        > -->
      </el-card>

      <!-- 岗位薪酬 -->
      <el-card
        style="position:relative"
        :class="[changeFields.includes('岗位薪酬') ? 'edit-background-color' : '', 'propject_detail_info_block']"
      >
        <div v-if="changeFields.includes('岗位薪酬')" class="propject_detail_info_block_handlers">
          <a class="mr5" @click="cancelEdit('岗位薪酬')">取消</a> <a @click="updateProjectInner('岗位薪酬')">保存</a>
        </div>
        <span v-else class="el-icon-edit-outline" @click="editProjectField('岗位薪酬')">编辑</span>
        <div class="title" style="position:static;padding-top:0;padding-right:0"><div class="name">岗位薪酬</div></div>
        <div v-if="!changeFields.includes('岗位薪酬')">
          <div class="content">
            <pre>{{ project['岗位薪酬'] }}</pre>
          </div>
        </div>
        <div v-else>
          <el-input v-if="changeFields.includes('岗位薪酬')" v-model="changes['岗位薪酬']" type="textarea" autosize />
        </div>
      </el-card>

      <!-- 可能的问题及应对 -->
      <el-card
        :class="[
          changeFields.includes('可能的问题及应对') ? 'edit-background-color' : '',
          'propject_detail_info_block',
        ]"
      >
        <div v-if="changeFields.includes('可能的问题及应对')" class="propject_detail_info_block_handlers">
          <a class="mr5" @click="cancelEdit('可能的问题及应对')">取消</a>
          <a @click="updateProjectInner('可能的问题及应对')">保存</a>
        </div>
        <span v-else class="el-icon-edit-outline" @click="editProjectField('可能的问题及应对')">编辑</span>
        <p class="propject_detail_info_title">
          可能的问题及应对{{ project['可能的问题及应对'] ? '' : '（暂无数据）' }}
        </p>
        <el-input
          v-if="changeFields.includes('可能的问题及应对')"
          v-model="changes['可能的问题及应对']"
          type="textarea"
          autosize
        />
        <pre v-else-if="project['可能的问题及应对']" ref="可能的问题及应对">{{ project['可能的问题及应对'] }}</pre>
        <!-- <el-link
          v-if="!changeFields.includes('可能的问题及应对') && isHiddenBtnShow['可能的问题及应对']"
          type="primary"
          :underline="false"
          :icon="isHidden['可能的问题及应对'] ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          style="cursor:pointer;position:absolute;bottom:20px;right:20px"
          @click="toggleHide('可能的问题及应对')"
          >{{ isHidden['可能的问题及应对'] ? '展开' : '收起' }}</el-link
        > -->
      </el-card>

      <!-- 公司详情 -->
      <el-card style="position:relative" class="propject_detail_info_block">
        <div class="title" style="position:static;padding-top:0;padding-right:0">
          <div class="name">
            <!-- <i class="el-icon-office-building"></i> -->
            公司详情
          </div>
          <div class="handel-btn">
            <el-link :underline="false" type="primary" icon="el-icon-office-building" @click="toCompanyDetail"
              >前往该公司</el-link
            >
            <el-link
              v-if="!departmentIsEditing"
              :underline="false"
              type="primary"
              style="margin-left:10px"
              @click="editDepartment"
              >编辑</el-link
            >
            <div v-else>
              <el-link :underline="false" type="primary" style="margin-left:10px" @click="cancelDepartment"
                >取消</el-link
              >
              <el-link :underline="false" type="primary" style="margin-left:10px" @click="saveDepartment">保存</el-link>
            </div>
          </div>
        </div>
        <div v-if="!departmentIsEditing">
          <div class="content">
            <div class="propject_detail_info_label">
              一句话介绍
              <p class="propject_detail_info_label pd10">{{ company['一句话简介'] }}</p>
            </div>
            <div class="flex-row justify-between">
              <div class="col-12 flex-column">
                <p class="propject_detail_info_label col-0">公司亮点</p>
                <div v-if="company['公司亮点'] && company['公司亮点'].keywords" class="flex-row flex-wrap">
                  <span
                    v-for="(value, key, index) in company['公司亮点'].keywords"
                    v-if="value"
                    :key="index"
                    class="label_tag"
                    >{{ key }}</span
                  >
                </div>
                <pre class="bg-gray">{{ (company['公司亮点'] && company['公司亮点'].content) || '' }}</pre>
              </div>
              <!-- <div class="col-6 flex-column">
                <p class="propject_detail_info_label col-0">部门情况</p>
                <pre class="bg-gray">{{ company['部门情况'] || project['部门情况'] }}</pre>
              </div> -->
            </div>
            <!-- <div class="flex-row mb10">
              <p class="propject_detail_info_label col-0 mr10">
                对接HR
                <el-popover v-if="company._id" v-model="companyHRVisible" placement="right" width="800" trigger="click">
                  <div class="propject_detail_info_table col-1">
                    <p style="text-align:center"><a @click="insertCompanyHr">新增</a>一位hr</p>
                    <div class="flex-row project_table_thead">
                      <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                      <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                      <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职级</span>
                      <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">手机</span>
                      <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">座机</span>
                      <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">邮箱</span>
                    </div>
                    <div
                      v-for="(value, i) in company['对接hr']"
                      :key="i"
                      :class="
                        `flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`
                      "
                      @click="addProjectHR(value)"
                    >
                      <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                      <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                      <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                      <span class="propject_detail_info_table_cell col-2">{{ value['手机'] }}</span>
                      <span class="propject_detail_info_table_cell col-2">{{ value['座机'] }}</span>
                      <span class="propject_detail_info_table_cell col-2">{{ value['邮箱'] }}</span>
                    </div>
                  </div>
                  <a slot="reference"> <i class="el-icon-search" /> </a>
                </el-popover>
              </p>
              <div class="propject_detail_info_table col-1">
                <div class="flex-row project_table_thead">
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职级</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">手机</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">座机</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">邮箱</span>
                </div>
                <div
                  v-for="(value, i) in projectHRs"
                  :key="i"
                  :class="`flex-row item-center propject_detail_info_table_row_delete ${i % 2 === 0 ? 'bg-gray' : ''}`"
                >
                  <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['手机'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['座机'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['邮箱'] }}</span>
                  <i class="el-icon-delete" @click="removeProjectHr(value)" />
                </div>
              </div>
            </div> -->
            <!-- <div class="flex-row mb10">
              <p class="propject_detail_info_label col-0 mr10">面试地址</p>
              <div class="propject_detail_info_table col-1">
                <div class="flex-row justify-between project_table_thead">
                  <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">地址</span>
                  <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">备注</span>
                </div>
                <div>
                  <div
                    v-for="(value, i) in project['面试地址']"
                    :key="i"
                    :class="`flex-row justify-between ${i % 2 === 0 ? 'bg-gray' : ''}`"
                  >
                    <span class="propject_detail_info_table_cell col-6">{{ value['地址'] }}</span>
                    <span class="propject_detail_info_table_cell col-6">{{ value['备注'] }}</span>
                  </div>
                </div>
              </div>
            </div> -->
            <div :style="{ height: 'auto' }" class="propject_detail_info_company_collapse">
              <div class="flex-row justify-between">
                <div class="col-4 flex-column">
                  <p class="propject_detail_info_label col-0">薪酬概况</p>
                  <pre class="bg-gray">{{ company['薪酬/职级/奖金机制'] }}</pre>
                </div>
                <div class="col-4 flex-column">
                  <p class="propject_detail_info_label col-0">业务特点/风格/资源来源</p>
                  <div
                    v-if="company['业务特点/风格/资源来源'] && company['业务特点/风格/资源来源'].keywords"
                    class="flex-row flex-wrap"
                  >
                    <span
                      v-for="(value, key, index) in company['业务特点/风格/资源来源'].keywords"
                      v-if="value"
                      :key="index"
                      class="label_tag"
                      >{{ companyKeyWordLabel[key] }}</span
                    >
                  </div>
                  <pre class="bg-gray">{{
                    company['业务特点/风格/资源来源'] && company['业务特点/风格/资源来源'].content
                  }}</pre>
                </div>
                <div class="col-4 flex-column">
                  <p class="propject_detail_info_label col-0">面试安排</p>
                  <pre class="bg-gray">{{ company['面试安排'] }}</pre>
                </div>
              </div>
            </div>
            <p class="propject_detail_info_label mb5">
              领导介绍
              <el-popover
                v-if="company._id"
                v-model="companyLeadersVisible"
                placement="right"
                trigger="click"
                width="600"
              >
                <div class="propject_detail_info_table col-1">
                  <p>没有找到想要的信息？点击 <a @click="showAddCompanyLeaderDialog">搜索</a>在数据库中搜索人选</p>
                  <div class="flex-row project_table_thead">
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                    <span class="propject_detail_info_table_cell col-1 propject_detail_info_label">简介</span>
                  </div>
                  <div
                    v-for="(value, i) in company['领导']"
                    :key="i"
                    :class="`flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`"
                    @click="addProjectLeader(value._id)"
                  >
                    <span class="propject_detail_info_table_cell col-2">{{ value.姓名 }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value.目前职位 }}</span>
                    <span class="propject_detail_info_table_cell col-1">{{ value.简介 }}</span>
                  </div>
                </div>
                <a slot="reference"> <i class="el-icon-search" /> </a>
              </el-popover>
            </p>
            <pre v-if="company['领导介绍']" class="propject_detail_info_label pd10">{{ company['领导介绍'] }}</pre>
            <div class="propject_detail_info_table col-1 mb5">
              <div class="flex-row justify-between project_table_thead">
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                <span class="propject_detail_info_table_cell col-1 propject_detail_info_label">简介</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label" />
              </div>
              <div
                v-for="(value, i) in projectLeaders"
                :key="i"
                :class="
                  `flex-row justify-between item-center propject_detail_info_table_row_delete ${
                    i % 2 === 0 ? 'bg-gray' : ''
                  }`
                "
              >
                <span class="propject_detail_info_table_cell col-2" @click="showRadish(value.rid)">{{
                  value.姓名
                }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value.目前职位 }}</span>
                <span class="propject_detail_info_table_cell col-1">{{ value.简介 }}</span>
                <span class="propject_detail_info_table_cell col-2">
                  <a v-if="value.rid" @click="getRadishAtta(value.rid)"> <i class="el-icon-document" />附件 </a>
                </span>
                <i class="el-icon-delete" @click="removeProjectLeader(value._id, i)" />
              </div>
            </div>
            <div class="mb10">
              <p class="propject_detail_info_label mb5">客户最关注的问题</p>
              <div
                v-for="(question, index) in company.关注问题"
                :key="`question${index}`"
                class="display-flex align-center mb5"
              >
                <span class="mr5">Q:</span>
                <p>{{ question }}</p>
              </div>

              <div
                v-for="(question, index) in project.关注问题"
                :key="`projectQuestion${index}`"
                class="display-flex align-center mb5"
              >
                <span class="mr5">Q:</span> <span>{{ question }}</span>
              </div>
            </div>
            <div class="mb10">
              <div>
                <p class="propject_detail_info_label">面试流程：</p>
                <pre>{{ project.面试流程 }}</pre>
              </div>
            </div>
            <div>
              <p class="propject_detail_info_label">关键面试决策人</p>
              <div class="display-flex flex-wrap">
                <div v-for="(item, index) in interviewer" :key="`interview${index}`" class="radish-card mr10 mb5">
                  <div style="width:40%">
                    <span class="name">
                      <!-- {{item.姓名}} -->
                      <span class="drawer-link" @click="showRadish(item._id)">{{ item.姓名 }}</span>
                    </span>
                    <span class="name" style="color:#000">
                      <span>{{ item.目前职位 }}</span>
                    </span>
                  </div>
                  <div class="width:60%">
                    <p class="tel">{{ item.手机 }}</p>
                    <p>{{ item.座机 }}</p>
                    <p>{{ item.邮箱 }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="propject_detail_info_label">
            一句话介绍
            <el-input v-model="changes['一句话简介']" placeholder="公司一句话简介" type="textarea" autosize />
          </div>
          <div class="flex-row justify-between">
            <div class="flex-column" style="width: 100%;">
              <p class="propject_detail_info_label col-0">公司亮点</p>
              <div class="flex-row flex-wrap">
                <a
                  v-for="(value, key, index) in changes['公司亮点'].keywords"
                  :key="index"
                  :class="`${value ? 'label_tag' : 'label_tag_default'}`"
                  @click="changes['公司亮点'].keywords[key] = !changes['公司亮点'].keywords[key]"
                  >{{ key }}</a
                >
              </div>
              <textarea v-model="changes['公司亮点'].content" class="col-1" />
            </div>
            <!-- <div class="col-6 flex-column">
              <p class="propject_detail_info_label col-0">部门情况</p>
              <textarea v-model="changes['部门情况']" class="col-1" />
            </div> -->
          </div>
          <!-- <div class="flex-row mb10">
            <p class="propject_detail_info_label col-0 mr10">
              对接HR
              <el-popover v-if="company._id" v-model="companyHRVisible" placement="right" width="800" trigger="click">
                <div class="propject_detail_info_table col-1">
                  <p style="text-align:center"><a @click="insertCompanyHr">新增</a>一位hr</p>
                  <div class="flex-row project_table_thead">
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职级</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">手机</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">座机</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">邮箱</span>
                  </div>
                  <div
                    v-for="(value, i) in company['对接hr']"
                    :key="i"
                    :class="`flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`"
                    @click="addProjectHR(value)"
                  >
                    <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['手机'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['座机'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['邮箱'] }}</span>
                  </div>
                </div>
                <a slot="reference"> <i class="el-icon-search" /> </a>
              </el-popover>
            </p>
            <div class="propject_detail_info_table col-1">
              <div class="flex-row project_table_thead">
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职级</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">手机</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">座机</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">邮箱</span>
              </div>
              <div
                v-for="(value, i) in projectHRs"
                :key="i"
                :class="`flex-row item-center propject_detail_info_table_row_delete ${i % 2 === 0 ? 'bg-gray' : ''}`"
              >
                <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['手机'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['座机'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['邮箱'] }}</span>
                <i class="el-icon-delete" @click="removeProjectHr(value)" />
              </div>
            </div>
          </div> -->
          <!-- <div class="flex-row mb10">
            <el-popover
              v-if="company._id"
              v-model="companyAddressVisible"
              placement="right"
              width="800"
              trigger="click"
            >
              <div class="propject_detail_info_table col-1" style="font-size:14px">
                <div class="flex-row justify-between project_table_thead item-center" style="min-height:40px">
                  <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">地址</span>
                  <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">备注</span>
                </div>
                <div
                  v-for="(value, i) in company['面试地址']"
                  :key="`address${i}`"
                  style="min-height:40px"
                  :class="
                    `flex-row justify-between propject_detail_info_table_row_link item-center ${
                      i % 2 === 0 ? 'bg-gray' : ''
                    }`
                  "
                  @click="addAddress2Project(value)"
                >
                  <span class="propject_detail_info_table_cell col-1">{{ value['地址'] }}</span>
                  <span class="propject_detail_info_table_cell col-6">{{ value['备注'] }}</span>
                </div>
              </div>
              <a slot="reference"> 面试地址 <i class="el-icon-circle-plus mb10" /> </a>
            </el-popover>
            <div
              v-if="project['面试地址'] && project['面试地址'].length > 0"
              class="propject_detail_info_table col-1"
              style="font-size:14px"
            >
              <div class="flex-row justify-between project_table_thead item-center" style="min-height:40px">
                <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">地址</span>
                <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">备注</span>
              </div>
              <div
                v-for="(value, i) in project['面试地址']"
                :key="`address${i}`"
                style="min-height:40px"
                :class="`flex-row justify-between item-center ${i % 2 === 0 ? 'bg-gray' : ''}`"
              >
                <a class="col-0" @click="removeCompanyAddress(value._id)"> <i class="el-icon-remove" /> </a>
                <span class="propject_detail_info_table_cell col-1">{{ value['地址'] }}</span>
                <span class="propject_detail_info_table_cell col-6">{{ value['备注'] }}</span>
              </div>
            </div>
          </div> -->
          <div :style="{ height: 'auto' }" class="propject_detail_info_company_collapse">
            <div class="flex-row justify-between">
              <div class="col-4 flex-column">
                <p class="propject_detail_info_label col-0">薪酬概况</p>
                <textarea v-model="changes['薪酬/职级/奖金机制']" class="col-1" />
              </div>
              <div class="col-4 flex-column">
                <p class="propject_detail_info_label col-0">业务特点/风格/资源来源</p>
                <div class="flex-row flex-wrap">
                  <a
                    v-for="(value, key, index) in changes['业务特点/风格/资源来源'].keywords"
                    :key="index"
                    :class="`${value ? 'label_tag' : 'label_tag_default'}`"
                    @click="changes['业务特点/风格/资源来源'].keywords[key] = !value"
                    >{{ companyKeyWordLabel[key] }}</a
                  >
                </div>
                <textarea v-model="changes['业务特点/风格/资源来源'].content" class="col-1" />
              </div>
              <div class="col-4 flex-column">
                <p class="propject_detail_info_label col-0">面试安排</p>
                <textarea v-model="changes['面试安排']" class="col-1" />
              </div>
            </div>
          </div>
          <p class="propject_detail_info_label mb5">
            领导介绍
            <el-popover
              v-if="company._id"
              v-model="companyLeadersVisible"
              placement="right"
              trigger="click"
              width="600"
            >
              <div class="propject_detail_info_table col-1">
                <p>没有找到想要的信息？点击 <a @click="showAddCompanyLeaderDialog">搜索</a>在数据库中搜索人选</p>
                <div class="flex-row project_table_thead">
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                  <span class="propject_detail_info_table_cell col-1 propject_detail_info_label">简介</span>
                </div>
                <div
                  v-for="(value, i) in company['领导']"
                  :key="i"
                  :class="`flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`"
                  @click="addProjectLeader(value._id)"
                >
                  <span class="propject_detail_info_table_cell col-2">{{ value.姓名 }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value.目前职位 }}</span>
                  <span class="propject_detail_info_table_cell col-1">{{ value.简介 }}</span>
                </div>
              </div>
              <a slot="reference"> <i class="el-icon-search" /> </a>
            </el-popover>
          </p>
          <el-input v-model="changes['领导介绍']" placeholder="领导介绍" type="textarea" autosize class="mb5" />
          <div class="propject_detail_info_table col-1 mb5">
            <div class="flex-row justify-between project_table_thead">
              <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
              <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
              <span class="propject_detail_info_table_cell col-1 propject_detail_info_label">简介</span>
              <span class="propject_detail_info_table_cell col-2 propject_detail_info_label" />
            </div>
            <div
              v-for="(value, i) in projectLeaders"
              :key="i"
              :class="
                `flex-row justify-between item-center propject_detail_info_table_row_delete ${
                  i % 2 === 0 ? 'bg-gray' : ''
                }`
              "
            >
              <span class="propject_detail_info_table_cell col-2" @click="showRadish(value.rid)">{{ value.姓名 }}</span>
              <span class="propject_detail_info_table_cell col-2">{{ value.目前职位 }}</span>
              <span class="propject_detail_info_table_cell col-1">{{ value.简介 }}</span>
              <span class="propject_detail_info_table_cell col-2">
                <a v-if="value.rid" @click="getRadishAtta(value.rid)"> <i class="el-icon-document" />附件 </a>
              </span>
              <i class="el-icon-delete" @click="removeProjectLeader(value._id, i)" />
            </div>
          </div>
          <div>
            <p class="propject_detail_info_label mb5">客户最关注的问题</p>
            <div
              v-for="(question, index) in company.关注问题"
              :key="`question${index}`"
              class="display-flex align-center mb5"
            >
              <span class="mr5">Q:</span>
              <p>{{ question }}</p>
            </div>

            <div
              v-for="(question, index) in changes.关注问题"
              :key="`projectQuestion${index}`"
              class="display-flex align-center mb5"
            >
              <span class="mr5">Q:</span>
              <el-input
                v-model="changes.关注问题[index]"
                placeholder="输入的问题会自动进入人选会谈"
                class="mr5"
                size="mini"
              ></el-input>
              <i class="ft-danger el-icon-delete" @click="removeQuestion(index)" />
            </div>
            <a @click="addQuestion"> <i class="el-icon-circle-plus" />增加一条问题 </a>
          </div>
          <div class="mb10">
            <div class="display-flex">
              <p class="propject_detail_info_label">面试流程：</p>
              <el-input
                v-model="changes.面试流程"
                type="textarea"
                :rows="3"
                :placeholder="
                  `例如：业务线电话直接约面试--业务领导见面（可能3个业务线的，也有可能直接部门B角）-A角见面-见投行委领导-后期可能会有测试（要考英语，财管计算等）`
                "
              ></el-input>
            </div>
          </div>
          <div>
            <a @click="addInterviewer"> 关键面试决策人 <i class="el-icon-circle-plus mb10" /> </a>
            <div class="display-flex flex-wrap">
              <div v-for="(item, index) in interviewer" :key="`interview${index}`" class="radish-card mr10 mb5">
                <span class="close" @click="removeInterviewer(item)">X</span>
                <div style="width:40%">
                  <span class="name">
                    <!-- {{item.姓名}} -->
                    <span class="drawer-link" @click="showRadish(item._id)">{{ item.姓名 }}</span>
                  </span>
                  <span class="name" style="color:#000">
                    <span>{{ item.目前职位 }}</span>
                  </span>
                </div>
                <div class="width:60%">
                  <p class="tel">{{ item.手机 }}</p>
                  <p>{{ item.座机 }}</p>
                  <p>{{ item.邮箱 }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-card>

      <!-- 项目话术 -->
      <el-card
        :class="[changeFields.includes('项目话术') ? 'edit-background-color' : '', 'propject_detail_info_block']"
      >
        <div v-if="changeFields.includes('项目话术')" class="propject_detail_info_block_handlers">
          <a class="mr5" @click="cancelEdit('项目话术')">取消</a> <a @click="updateProjectInner('项目话术')">保存</a>
        </div>
        <span v-else class="el-icon-edit-outline" @click="editProjectField('项目话术')">编辑</span>
        <p class="propject_detail_info_title">
          职位话术{{ project['职位话术'] || genPositionSpeech(project, company) ? '' : '（暂无数据）' }}
        </p>
        <el-input v-if="changeFields.includes('项目话术')" v-model="changes['项目话术']" type="textarea" autosize />
        <pre
          v-else-if="project['项目话术'] || genPositionSpeech(project, company)"
          ref="项目话术"
          :class="isHidden['项目话术'] ? 'hidden' : ''"
          >{{ project['项目话术'] || genPositionSpeech(project, company) }}</pre
        >
        <el-link
          v-if="!changeFields.includes('项目话术') && isHiddenBtnShow['项目话术']"
          type="primary"
          :underline="false"
          :icon="isHidden['项目话术'] ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          style="cursor:pointer;position:absolute;bottom:20px;right:20px"
          @click="toggleHide('项目话术')"
          >{{ isHidden['项目话术'] ? '展开' : '收起' }}</el-link
        >
      </el-card>
    </div>
    <div ref="propject_detail_secondary" class="col-0 propject_detail_secondary">
      <!-- 项目概况 -->
      <el-card style="position:relative" class="propject_detail_info_block">
        <div class="title" style="width:auto">
          <div class="name"><!-- <i class="el-icon-office-building"></i> --></div>
          <div class="handel-btn">
            <el-link
              v-if="!infoIsEditing"
              :underline="false"
              type="primary"
              :icon="showInfoDetail ? 'el-icon-zoom-out' : 'el-icon-zoom-in'"
              @click="showInfoDetail = !showInfoDetail"
              >{{ showInfoDetail ? '收起' : '查看更多' }}</el-link
            >
            <el-link v-if="!infoIsEditing" :underline="false" type="primary" style="margin-left:10px" @click="editInfo"
              >编辑</el-link
            >
            <div v-else>
              <el-link :underline="false" type="primary" style="margin-left:10px" @click="cancelInfo">取消</el-link>
              <el-link :underline="false" type="primary" style="margin-left:10px" @click="saveInfo">保存</el-link>
            </div>
          </div>
        </div>
        <div v-if="!infoIsEditing">
          <div class="content">
            <p class="propject_detail_info_title mb10">职位名称:{{ project.项目名称 || '--' }}</p>
            <p class="project_detail_item"><b>项目编号:</b>{{ project.编号 }}</p>
            <!-- <el-row :gutter="20">
              <el-col :span="6">
                <b>职位名称:{{ project.项目名称 || '--' }}</b>
              </el-col>
            </el-row> -->
            <div class="project_detail_box">
              <div class="project_detail_item">
                <b>客户公司:</b><span> {{ project.客户公司 || '--' }}</span>
              </div>
              <div class="project_detail_item">
                <b>用人部门:</b> <span>{{ project.部门 || '--' }}</span>
              </div>
              <div class="project_detail_item">
                <b>办公地:</b>
                <span v-if="project.办公地 && project.办公地.length > 0">
                  <span v-for="(item, idx) in project.办公地" :key="idx"
                    >{{ item }}{{ idx === project.办公地.length - 1 ? '' : ' , ' }}</span
                  >
                </span>
                <span v-else>--</span>
              </div>
              <div class="project_detail_item">
                <b>优先级:</b><span> {{ youxianji[project.优先级 - 1] || '--' }}</span>
              </div>
              <div class="project_detail_item">
                <b>工作年限:</b><span> {{ formatRange(project.工作年限, '年') }}</span>
              </div>
              <div class="project_detail_item">
                <b>年龄要求:</b><span>{{ formatRange(project.年龄要求, '岁') }}</span>
              </div>
              <div v-if="showInfoDetail" class="project_detail_item">
                <b>年薪范围:</b><span> {{ formatRange(project.年薪范围, '万') }}</span>
              </div>
              <div v-if="showInfoDetail" class="project_detail_item">
                <b>月薪范围要求:</b><span> {{ formatRange(project.月薪范围要求, '万') }}</span>
              </div>
              <div v-if="showInfoDetail" class="project_detail_item">
                <b>专业职级:</b>
                <span v-if="project.专业职级 && project.专业职级.length > 0">
                  <span v-for="(item, idx) in project.专业职级" :key="idx"
                    >{{ item }}{{ idx === project.专业职级.length - 1 ? '' : ' , ' }}</span
                  >
                </span>
                <span v-else>--</span>
              </div>
              <div v-if="showInfoDetail" class="project_detail_item">
                <b>管理职级:</b> <span>{{ project.管理职级 || '--' }}</span>
              </div>
              <div v-if="showInfoDetail" class="project_detail_item">
                <b>项目状态:</b> <span>{{ project.项目状态 || '--' }}</span>
              </div>
              <div v-if="showInfoDetail" class="project_detail_item">
                <b>是否为独家:</b> <span>{{ project.独家 ? '是独家' : '非独家' }}</span>
              </div>
              <div v-if="showInfoDetail" class="project_detail_item">
                <b>招聘数量:</b> <span>{{ project.招聘数量 || '--' }}</span>
              </div>
              <div v-if="showInfoDetail" class="project_detail_item">
                <b>开始日期:</b>
                <span>{{
                  project.startTime ? dateFormat(new Date(parseInt(project.startTime, 10)), 'yyyy-mm-dd') : '--'
                }}</span>
              </div>
              <div v-if="showInfoDetail" class="project_detail_item">
                <b>保质期:</b>
                <span>{{
                  project.guaranteeTime ? dateFormat(new Date(parseInt(project.guaranteeTime, 10)), 'yyyy-mm-dd') : '--'
                }}</span>
              </div>
              <div v-if="showInfoDetail" class="project_detail_item">
                <b>预计第一批人选推荐:</b>
                <span>{{
                  project.indroduceTime ? dateFormat(new Date(parseInt(project.indroduceTime, 10)), 'yyyy-mm-dd') : '--'
                }}</span>
              </div>
            </div>
            <!-- <el-row :gutter="20">
              <el-col :span="6"> <b>客户公司:</b> {{ project.客户公司 || '--' }} </el-col>
              <el-col :span="6"> <b>用人部门:</b> {{ project.部门 || '--' }} </el-col>
              <el-col :span="6">
                <b>办公地:</b>
                <span v-if="project.办公地 && project.办公地.length > 0">
                  <span v-for="(item, idx) in project.办公地" :key="idx"
                    >{{ item }}{{ idx === project.办公地.length - 1 ? '' : ' , ' }}</span
                  >
                </span>
                <span v-else>--</span>
              </el-col>
              <el-col :span="6"> <b>优先级:</b> {{ youxianji[project.优先级 - 1] || '--' }} </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6"> <b>工作年限:</b> {{ formatRange(project.工作年限, '年') }} </el-col>
              <el-col :span="6"> <b>年龄要求:</b> {{ formatRange(project.年龄要求, '岁') }} </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="6"> <b>年薪范围:</b> {{ formatRange(project.年薪范围, '万') }} </el-col>
              <el-col :span="6"> <b>月薪范围要求:</b> {{ formatRange(project.月薪范围要求, '万') }} </el-col>
              <el-col :span="6">
                <b>专业职级:</b>
                <span v-if="project.专业职级 && project.专业职级.length > 0">
                  <span v-for="(item, idx) in project.专业职级" :key="idx"
                    >{{ item }}{{ idx === project.专业职级.length - 1 ? '' : ' , ' }}</span
                  >
                </span>
                <span v-else>--</span>
              </el-col>
              <el-col :span="6"> <b>管理职级:</b> {{ project.管理职级 || '--' }} </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6"> <b>项目状态:</b> {{ project.项目状态 || '--' }} </el-col>
              <el-col :span="6"> <b>是否为独家:</b> {{ project.独家 ? '是独家' : '非独家' }} </el-col>
              <el-col :span="6"> <b>招聘数量:</b> {{ project.招聘数量 || '--' }} </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <b>开始日期:</b>
                {{ project.startTime ? dateFormat(new Date(parseInt(project.startTime, 10)), 'yyyy-mm-dd') : '--' }}
              </el-col>
              <el-col :span="6">
                <b>保质期:</b>
                {{
                  project.guaranteeTime ? dateFormat(new Date(parseInt(project.guaranteeTime, 10)), 'yyyy-mm-dd') : '--'
                }}
              </el-col>
              <el-col :span="10">
                <b>预计第一批人选推荐:</b>
                {{
                  project.indroduceTime ? dateFormat(new Date(parseInt(project.indroduceTime, 10)), 'yyyy-mm-dd') : '--'
                }}
              </el-col>
            </el-row> -->
          </div>
          <!-- <div v-else class="content">
            <el-row :gutter="20">
              <el-col :span="6">
                <b>职位名称:{{ project.项目名称 || '--' }}</b>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="4">
                <b>客户开发:</b>
                <span v-if="project.客户开发 && project.客户开发.length > 0">
                  <span v-for="(item, idx) in project.客户开发" :key="idx"
                    >{{ item }}{{ idx === project.客户开发.length - 1 ? '' : ' , ' }}</span
                  >
                </span>
                <span v-else>--</span>
              </el-col>
              <el-col :span="4">
                <b>项目对接:</b>
                <span v-if="project.项目对接 && project.项目对接.length > 0">
                  <span v-for="(item, idx) in project.项目对接" :key="idx"
                    >{{ item }}{{ idx === project.项目对接.length - 1 ? '' : ' , ' }}</span
                  >
                </span>
                <span v-else>--</span>
              </el-col>
              <el-col :span="4">
                <b>项目经理:</b>
                <span v-if="project.项目经理 && project.项目经理.length > 0">
                  <span v-for="(item, idx) in project.项目经理" :key="idx"
                    >{{ item }}{{ idx === project.项目经理.length - 1 ? '' : ' , ' }}</span
                  >
                </span>
                <span v-else>--</span>
              </el-col>
              <el-col :span="8">
                <b>参与成员:</b>
                <span v-if="project.项目成员 && project.项目成员.length > 0">
                  <span v-for="(item, idx) in project.项目成员" :key="idx"
                    >{{ item }}{{ idx === project.项目成员.length - 1 ? '' : ' , ' }}</span
                  >
                </span>
                <span v-else>--</span>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" size="small" @click="editPartners">编辑项目成员</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6"> <b>客户公司:</b> {{ project.客户公司 || '--' }} </el-col>
              <el-col :span="6"> <b>用人部门:</b> {{ project.部门 || '--' }} </el-col>
              <el-col :span="6">
                <b>办公地:</b>
                <span v-if="project.办公地 && project.办公地.length > 0">
                  <span v-for="(item, idx) in project.办公地" :key="idx"
                    >{{ item }}{{ idx === project.办公地.length - 1 ? '' : ' , ' }}</span
                  >
                </span>
                <span v-else>--</span>
              </el-col>
              <el-col :span="6"> <b>优先级:</b> {{ youxianji[project.优先级 - 1] || '--' }} </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6"> <b>工作年限:</b> {{ formatRange(project.工作年限, '年') }} </el-col>
              <el-col :span="6"> <b>年龄要求:</b> {{ formatRange(project.年龄要求, '岁') }} </el-col>
            </el-row>
          </div> -->
        </div>
        <div v-else style="margin-top:20px">
          <div class="flex-row flex-wrap">
            <div class="flex-row item-center mr10 mb5">
              <div
                :class="`col-0 propject_detail_info_label mr5 ${errors['客户公司'] ? 'ft-danger' : ''}`"
                title="必填项"
              >
                客户公司 <i class="el-icon-info" />
              </div>
              <el-autocomplete
                v-model="infoInEdit['客户公司']"
                :fetch-suggestions="searchCompany"
                size="mini"
                placeholder="搜索关键字"
                class="col-1"
              />
            </div>
            <div class="mr10 mb5">
              <el-popover v-model="addCompanyVisible" placement="right" width="400" trigger="click">
                <div>
                  <div class="flex-row mb10">
                    <span
                      :class="
                        `propject_detail_info_label col-0 propject_detail_info_files_cell_1 ${
                          errors['公司全称'] ? 'ft-danger' : ''
                        }`
                      "
                      title="必填项"
                    >
                      公司全称 <i class="el-icon-info" />
                    </span>
                    <el-autocomplete
                      v-model="companyFullname"
                      :fetch-suggestions="searchCompanyFullname"
                      placeholder="搜索关键字"
                      size="mini"
                      class="col-1"
                    />
                  </div>
                  <div class="flex-row mb10">
                    <span class="propject_detail_info_label col-0 propject_detail_info_files_cell_1" title="必填项">
                      简称 <i class="el-icon-info" />
                    </span>
                    <el-input v-model="companyShortname" :disabled="true" class="col-1" size="mini" />
                  </div>
                  <div class="flex-row mb10">
                    <span
                      :class="
                        `propject_detail_info_label col-0 propject_detail_info_files_cell_1 ${
                          errors['行业'] ? 'ft-danger' : ''
                        }`
                      "
                      title="必填项"
                    >
                      行业 <i class="el-icon-info" />
                    </span>
                    <el-select v-model="companyIndustry" filterable size="mini">
                      <el-option v-for="(value, i) in industry" :key="i" :value="value" :label="value" />
                    </el-select>
                  </div>
                  <div class="text-right">
                    <el-button size="mini" @click="addCompanyVisible = false">取 消</el-button>
                    <el-button
                      :disabled="companyPendding || errors['公司全称']"
                      size="mini"
                      type="primary"
                      @click="createCompany"
                      >确 定</el-button
                    >
                  </div>
                </div>
                <el-button slot="reference" :disabled="showNewComBtn" type="primary" size="mini">新建公司</el-button>
              </el-popover>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">部门</div>
              <el-input v-model="infoInEdit['部门']" size="mini" class="col-1" />
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div
                :class="`col-0 propject_detail_info_label mr5 ${errors['项目名称'] ? 'ft-danger' : ''}`"
                title="必填项"
              >
                项目名称 <i class="el-icon-info" />
              </div>
              <el-input v-model="infoInEdit['项目名称']" size="mini" class="col-1" />
            </div>
            <div class="flex-row item-center mb5">
              <div class="col-0 propject_detail_info_label mr5">办公地</div>
              <div class="col-1">
                <el-select
                  v-model="infoInEdit['办公地']"
                  multiple
                  filterable
                  allow-create
                  placeholder="搜索关键字"
                  size="mini"
                  class="full-width"
                >
                  <el-option v-for="(value, i) in locations" :key="i" :value="value" :label="value" />
                </el-select>
              </div>
            </div>
          </div>
          <div class="flex-row flex-wrap">
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">开始日期</div>
              <el-date-picker
                v-model="infoInEdit.startTime"
                type="date"
                size="mini"
                value-format="timestamp"
                class="mini_datetime_picker project_info_datepicker"
              />
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">保证期</div>
              <el-date-picker
                v-model="infoInEdit.guaranteeTime"
                type="date"
                size="mini"
                value-format="timestamp"
                class="mini_datetime_picker project_info_datepicker"
              />
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">预计第一批人推荐时间</div>
              <el-date-picker
                v-model="infoInEdit.indroduceTime"
                type="date"
                size="mini"
                value-format="timestamp"
                class="mini_datetime_picker project_info_datepicker"
              />
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">年龄要求</div>
              <div class="flex-row item-center">
                <el-input v-model="infoInEdit['年龄要求'][0]" class="project_detail_number_input" size="mini" />~
                <el-input v-model="infoInEdit['年龄要求'][1]" class="project_detail_number_input" size="mini" />年
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">工作年限</div>
              <div class="flex-row item-center">
                <el-input v-model="infoInEdit['工作年限'][0]" class="project_detail_number_input" size="mini" />~
                <el-input v-model="infoInEdit['工作年限'][1]" class="project_detail_number_input" size="mini" />年
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">年薪范围</div>
              <div class="flex-row item-center">
                <el-input v-model="infoInEdit['年薪范围'][0]" class="project_detail_number_input" size="mini" />~
                <el-input v-model="infoInEdit['年薪范围'][1]" class="project_detail_number_input" size="mini" />万
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">月薪范围</div>
              <div class="flex-row item-center">
                <el-input v-model="infoInEdit['月薪范围'][0]" class="project_detail_number_input" size="mini" />~
                <el-input v-model="infoInEdit['月薪范围'][1]" class="project_detail_number_input" size="mini" />万
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">项目状态</div>
              <div class="project_detail_select_input">
                <el-select v-model="infoInEdit['项目状态']" filterable size="mini">
                  <el-option v-for="(value, i) in projectStatus" :key="i" :value="value" :label="value" />
                </el-select>
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">专业职级</div>
              <div>
                <el-select v-model="infoInEdit['专业职级']" multiple filterable size="mini">
                  <el-option v-for="(item, i) in professionalRank" :key="i" :value="item.value" :label="item.label" />
                </el-select>
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">管理职级</div>
              <el-input v-model="infoInEdit['管理职级']" size="mini" class="col-1" />
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">招聘数量</div>
              <div class="project_detail_number_input col-1">
                <el-input v-model="infoInEdit['招聘数量']" size="mini" />
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">优先级</div>
              <el-rate v-model="infoInEdit['优先级']" :colors="['#99A9BF', '#F7BA2A', '#F56C6C']" />
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">独家职位：</div>
              <el-checkbox v-model="infoInEdit['独家']"></el-checkbox>
            </div>
          </div>
        </div>
      </el-card>

      <!-- 人才画像 -->
      <el-card :class="[portraitEditing ? 'edit-background-color' : '', 'propject_detail_info_block']">
        <div v-if="portraitEditing" class="propject_detail_info_block_handlers">
          <a class="mr5" @click="editPortraitToggle">取消</a> <a @click="savePortraitEdit">保存</a>
        </div>
        <span v-else class="el-icon-edit-outline" @click="editPortraitToggle">编辑</span>
        <p class="propject_detail_info_title">人才画像</p>
        <el-row :gutter="20">
          <el-col :span="20">
            <div v-if="portraitEditing" class="flex-row flex-wrap propject_detail_info_block_item">
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">职能模块</div>
                <el-autocomplete
                  v-model="changes['职能模块']"
                  :fetch-suggestions="(queryString, cb) => searchCategory(queryString, cb, categoryOptions)"
                  size="mini"
                  class="col-1"
                />
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">平台</div>
                <div class="col-1">
                  <el-select v-model="changes['平台']" multiple size="mini" class="full-width">
                    <el-option v-for="(value, i) in ['A', 'B', 'C']" :key="i" :value="value" :label="value" />
                  </el-select>
                </div>
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">细分职能</div>
                <div class="col-1">
                  <el-select v-model="changes['细分职能']" filterable multiple size="mini" class="full-width">
                    <el-option v-for="(value, i) in 细分职能options" :key="i" :value="value" :label="value" />
                  </el-select>
                </div>
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">业绩</div>
                <div class="col-1">
                  <el-select v-model="changes['业绩']" filterable multiple size="mini" class="full-width">
                    <el-option v-for="(value, i) in 业绩options" :key="i" :value="value" :label="value" />
                  </el-select>
                </div>
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">擅长方向</div>
                <div class="col-1">
                  <el-select v-model="changes['擅长方向']" multiple filterable size="mini" class="full-width">
                    <el-option v-for="(value, i) in 擅长方向options" :key="i" :value="value" :label="value" />
                  </el-select>
                </div>
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">职级</div>
                <div class="col-1">
                  <el-select v-model="changes['职级']" filterable multiple size="mini" class="full-width">
                    <el-option
                      v-for="(item, i) in professionalLevel"
                      :key="i"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </div>
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">目标行业</div>
                <div class="col-1">
                  <el-select v-model="changes['目标行业']" multiple filterable size="mini" class="full-width">
                    <el-option v-for="(value, i) in industry" :key="i" :value="value" :label="value" />
                  </el-select>
                </div>
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">地域</div>
                <div class="col-1">
                  <el-select v-model="changes['地域']" multiple filterable allow-create size="mini" class="full-width">
                    <el-option v-for="(value, i) in locations" :key="i" :value="value" :label="value" />
                  </el-select>
                </div>
              </div>
            </div>

            <div v-else class="flex-row flex-wrap propject_detail_info_block_item">
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">职能模块</div>
                <div class="col-1 flex-row flex-wrap">
                  <span v-if="project['职能模块']" class="label_tag">{{ project['职能模块'] }}</span>
                </div>
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">平台</div>
                <div class="col-1 flex-row flex-wrap">
                  <span v-for="(value, i) in project['平台']" :key="i" class="label_tag">{{ value }}</span>
                </div>
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">细分职能</div>
                <div class="col-1 flex-row flex-wrap">
                  <span v-for="(value, i) in project['细分职能']" :key="i" class="label_tag">{{ value }}</span>
                </div>
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">业绩</div>
                <div class="col-1 flex-row flex-wrap">
                  <span v-for="(value, i) in project['业绩']" :key="i" class="label_tag">{{ value }}</span>
                </div>
              </div>

              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">擅长方向</div>
                <div class="col-1 flex-row flex-wrap">
                  <span v-for="(value, i) in project['擅长方向']" :key="i" class="label_tag">{{ value }}</span>
                </div>
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">职级</div>
                <div class="col-1 flex-row flex-wrap">
                  <span v-for="(value, i) in project['职级']" :key="i" class="label_tag">{{ value }}</span>
                </div>
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">目标行业</div>
                <div class="col-1 flex-row flex-wrap">
                  <span v-for="(value, i) in project['目标行业']" :key="i" class="label_tag">{{ value }}</span>
                </div>
              </div>
              <div class="flex-row col-6">
                <div class="col-0 propject_detail_info_label">地域</div>
                <div class="col-1 flex-row flex-wrap">
                  <span v-for="(value, i) in project['地域']" :key="i" class="label_tag">{{ value }}</span>
                </div>
              </div>
            </div>
            <div v-if="portraitEditing">
              <el-alert title="标签可拖拽排序，前五会重点展示" type="warning" style="margin:4px 0" />
              <div class="tagsort-box">
                <el-tag
                  v-for="(tag, index) in changes['标签']"
                  :key="index"
                  size="mini"
                  style="margin:0 4px 4px 0"
                  closable
                  draggable="true"
                  type="warning"
                  @drop.native="event => drop(event, index)"
                  @dragover.native="event => allowDrop(event, index)"
                  @dragstart.native="() => drag(index)"
                  @close="dragtagclose(tag, index)"
                  >{{ tag }}</el-tag
                >
              </div>
              <div>
                <el-input
                  v-if="tagInputVisible"
                  ref="saveTagInput"
                  v-model="tagInput"
                  size="mini"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                />
                <el-button v-else class="button-new-tag" size="mini" @click="showInput">+ 新标签</el-button>
              </div>
              <div v-for="(tagGroup, i) in tags" :key="i" class="pd-10">
                <div class="project-item-label">{{ tagGroup.label }}</div>
                <el-checkbox-group v-model="changes['标签']" class="flex-row flex-wrap">
                  <el-checkbox v-for="tag in tagGroup.children" :key="tag" :label="tag" class="check-item mr10" />
                </el-checkbox-group>
              </div>
            </div>
            <div v-else-if="project['标签'] && project['标签'].length > 0" class="propject_detail_info_block_item">
              <TagShow :tags="project['标签']" />
            </div>

            <div>
              <div style="font-size:14px;font-weight:600">整体情况</div>
              <el-input
                v-if="portraitEditing"
                v-model="changes['人才画像补充']"
                type="textarea"
                autosize
                placeholder="对人才画像的补充"
              />
              <pre v-else ref="人才画像补充" style="margin:0">{{ project['人才画像补充'] }}</pre>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div>
              <p class="propject_detail_info_label">
                目标公司 <a @click="selectCompany"> <i class="el-icon-circle-plus" /> </a>
              </p>
              <div v-if="changeFields.includes('目标公司备注')">
                <el-input v-model="changes['目标公司备注']" placeholder="目标公司" type="textarea" autosize />
              </div>
              <div v-else-if="project['目标公司备注']" class="pd10">{{ project['目标公司备注'] }}</div>
              <div class="flex-row flex-wrap">
                <a v-for="(value, i) in project['目标公司']" :key="i" class="label_tag" @click="showCompany(value)">
                  {{ value }}
                </a>
              </div>
            </div>
            <div style="margin-top:10px;">
              <p class="propject_detail_info_label">
                不倾向公司 <a @click="selectCompany1"> <i class="el-icon-circle-plus" /> </a>
              </p>
              <div v-if="changeFields.includes('不倾向公司备注')">
                <el-input v-model="changes['不倾向公司备注']" placeholder="不倾向公司" type="textarea" autosize />
              </div>
              <div v-else-if="project['不倾向公司备注']" class="pd10">{{ project['不倾向公司备注'] }}</div>
              <div class="flex-row flex-wrap">
                <a v-for="(value, i) in project['不倾向公司']" :key="i" class="label_tag" @click="showCompany(value)">
                  {{ value }}
                </a>
              </div>
            </div>
            <div style="margin-top:10px;">
              <p class="propject_detail_info_label">勿推荐公司(来源:公司)：</p>
              <el-tag v-for="item in company.勿推荐公司" :key="item" class="mr4 md4" size="mini" type="danger">{{
                item
              }}</el-tag>
            </div>
            <div style="margin-top:10px;">
              <p class="propject_detail_info_label">
                目标人选 <a @click="editProjectTargetRadishes"> <i class="el-icon-circle-plus" /> </a>
              </p>
              <div>
                <el-input
                  v-if="changeFields.includes('目标人选备注')"
                  v-model="changes['目标人选备注']"
                  placeholder="目标人选"
                  type="textarea"
                  autosize
                />
              </div>
              <div v-if="project['目标人选备注']" class="pd10">{{ project['目标人选备注'] }}</div>
              <div class="flex-row flex-wrap">
                <a
                  v-for="(value, i) in project['目标人选']"
                  :key="i"
                  class="label_tag"
                  @click="showRadishDetail({ _id: value.rid, 姓名: value.name })"
                  >{{ value.name }}</a
                >
              </div>
            </div>
            <div style="margin-top:10px;">
              <p class="propject_detail_info_label">阿尔法认知：</p>
              <el-input
                v-if="changeFields.includes('阿尔法认知')"
                v-model="changes['阿尔法认知']"
                placeholder="阿尔法认知"
                type="textarea"
                autosize
              />
              <pre v-else>{{ project['阿尔法认知'] }}</pre>
            </div>
          </el-col> -->
        </el-row>
      </el-card>

      <!-- 项目打分 -->
      <ProjectGrade ref="ProjectGrade" :project="project" :company="company"></ProjectGrade>

      <!-- 项目沟通备注 -->
      <el-card class="propject_detail_info_block" style="height:300px;overflow:scroll">
        <p class="propject_detail_info_title" style="margin-bottom:10px">项目沟通备注</p>
        <div v-if="project.remark && project.remark.length > 0" class="context">
          <div v-for="(item, idx) in project.remark" :key="idx" class="remark-item">
            <div class="remark-item-title" style="margin-bottom:5px;font-size:14px;color:#409eff">
              <span style="margin-right:10px">{{ dateFormat(new Date(item.createAt), 'yyyy-mm-dd HH:MM') }}</span>
              <span>{{ item.user }}</span>
            </div>
            <div class="remark-item-content" style="font-size:14px;line-height:20px">
              <pre>{{ item.remark }}</pre>
            </div>
          </div>
        </div>
        <div>
          <el-input
            v-model="remark"
            type="textarea"
            style="margin-bottom:10px"
            placeholder="请填写沟通备注"
            :autosize="{ minRows: 3, maxRows: 5 }"
          ></el-input>
          <el-button type="primary" size="small" @click="saveRemark">保存</el-button>
        </div>
      </el-card>

      <!-- 失败人选 -->
      <el-card v-if="finalRadishes.length > 0" class="propject_detail_info_block">
        <!-- <p class="propject_detail_info_title">对接hr</p> -->
        <p class="propject_detail_info_label col-0 mr10 mb10">失败人选</p>
        <div class="">
          <div v-for="(item, index) in finalRadishes" :key="`finalRadish${index}`" class="mr10 mb5">
            <p>
              <span>入职人选：</span
              ><span class="drawer-link mr10" @click="showRadish(item._id)">{{ item.姓名 }}</span>
              <span>人选来源：</span><span>{{ project.finalRadishFrom }}</span>
            </p>
            <p>失败原因：{{ project.failReason }}</p>
          </div>
        </div>
      </el-card>

      <!-- 项目成员 -->
      <el-card class="propject_detail_info_block">
        <p class="propject_detail_info_title">项目成员</p>
        <el-button
          type="primary"
          size="mini"
          style="color: #fff;"
          class="propject_detail_info_block_handlers"
          @click="editPartners"
          >编辑项目成员</el-button
        >
        <div class="project_context">
          <div v-for="type in ['客户开发', '项目对接', '项目经理', '项目成员']" :key="type" class="project_member-box">
            <b>{{ type }}:</b>
            <span v-if="project[type] && project[type]['length'] > 0">
              <span v-for="(item, idx) in project[type]" :key="idx"
                >{{ item }}{{ idx === project[type].length - 1 ? '' : ' , ' }}</span
              >
            </span>
            <span v-else>--</span>
          </div>
        </div>
        <!-- <div class="context"><ProjectSteps :project="project"></ProjectSteps></div> -->
      </el-card>

      <!-- 对接hr -->
      <el-card class="propject_detail_info_block">
        <!-- <p class="propject_detail_info_title">对接hr</p> -->
        <p class="propject_detail_info_label col-0 mr10">
          对接HR
          <el-popover v-if="company._id" v-model="companyHRVisible" placement="right" width="800" trigger="click">
            <div class="propject_detail_info_table col-1">
              <p style="text-align:center"><a @click="insertCompanyHr">新增</a>一位hr</p>
              <div class="flex-row project_table_thead">
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职级</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">手机</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">座机</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">邮箱</span>
              </div>
              <div
                v-for="(value, i) in company['对接hr']"
                :key="i"
                :class="`flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`"
                @click="addProjectHR(value)"
              >
                <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['手机'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['座机'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['邮箱'] }}</span>
              </div>
            </div>
            <a slot="reference"> <i class="el-icon-search" /> </a>
          </el-popover>
        </p>
        <div class="display-flex flex-wrap">
          <div v-for="(item, index) in projectHRs" :key="`interview${index}`" class="radish-card mr10 mb5">
            <span class="close" @click="removeProjectHr(item)">X</span>
            <div style="width:40%">
              <span class="name">
                <!-- {{item.姓名}} -->
                <span :class="{ 'drawer-link': item.rid }" @click="showRadish(item.rid)">{{ item.姓名 }}</span>
              </span>
              <span class="name" style="color:#000">
                <span>{{ item.目前职位 }}</span>
              </span>
            </div>
            <div class="width:60%">
              <p class="tel">{{ item.手机 }}</p>
              <p>{{ item.座机 }}</p>
              <p>{{ item.邮箱 }}</p>
            </div>
          </div>
        </div>

        <!-- 面试地址 -->
        <el-popover v-if="company._id" v-model="companyAddressVisible" placement="right" width="800" trigger="click">
          <div class="propject_detail_info_table col-1" style="font-size:14px">
            <div class="flex-row justify-between project_table_thead item-center" style="min-height:40px">
              <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">地址</span>
              <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">备注</span>
            </div>
            <div
              v-for="(value, i) in company['面试地址']"
              :key="`address${i}`"
              style="min-height:40px"
              :class="
                `flex-row justify-between propject_detail_info_table_row_link item-center ${
                  i % 2 === 0 ? 'bg-gray' : ''
                }`
              "
              @click="addAddress2Project(value)"
            >
              <span class="propject_detail_info_table_cell col-1">{{ value['地址'] }}</span>
              <span class="propject_detail_info_table_cell col-6">{{ value['备注'] }}</span>
            </div>
          </div>
          <a slot="reference" style="display: flex;word-break: keep-all;">
            面试地址 <i class="el-icon-circle-plus mb10" />
          </a>
        </el-popover>
        <div class="flex-row mb10">
          <div
            v-if="project['面试地址'] && project['面试地址'].length > 0"
            class="propject_detail_info_table col-1"
            style="font-size:14px"
          >
            <div class="flex-row justify-between project_table_thead item-center" style="min-height:40px">
              <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">地址</span>
              <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">备注</span>
            </div>
            <div
              v-for="(value, i) in project['面试地址']"
              :key="`address${i}`"
              style="min-height:40px"
              :class="`flex-row justify-between item-center ${i % 2 === 0 ? 'bg-gray' : ''}`"
            >
              <a class="col-0" @click="removeCompanyAddress(value._id)"> <i class="el-icon-remove" /> </a>
              <span class="propject_detail_info_table_cell col-1">{{ value['地址'] }}</span>
              <span class="propject_detail_info_table_cell col-6">{{ value['备注'] }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="context"><ProjectSteps :project="project"></ProjectSteps></div> -->
      </el-card>

      <!-- 项目阶段进展汇总 -->
      <el-card class="propject_detail_info_block" style="height:500px">
        <p class="propject_detail_info_title">项目阶段进展汇总</p>
        <div class="context"><ProjectSteps :project="project"></ProjectSteps></div>
      </el-card>

      <!-- 附件 -->
      <el-card class="propject_detail_info_block">
        <p class="propject_detail_info_title">
          附件 <a @click="beforeUpload()"> <i class="el-icon-circle-plus" /> </a>
        </p>
        <div class="propject_detail_info_table">
          <div class="flex-row project_table_thead">
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_0 propject_detail_info_label"
              >类型</span
            >
            <span
              class="propject_detail_info_table_cell propject_detail_info_files_cell_1 propject_detail_info_label col-1"
              >文件名</span
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 propject_detail_info_label"
              >上传时间</span
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_3 propject_detail_info_label"
              >上传人</span
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_4 propject_detail_info_label"
              >操作</span
            >
          </div>
          <div v-for="(file, i) in files" :key="i" :class="`flex-row item-center ${i % 2 === 0 ? 'bg-gray' : ''}`">
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_0 col-0">{{ file.type }}</span>
            <a class="propject_detail_info_table_cell propject_detail_info_files_cell_1 col-1" @click="preview(file)">{{
              file.originalname
            }}</a>
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 col-0">{{
              file.createdAt ? dateFormat(new Date(parseInt(file.createdAt, 10)), 'yyyy-mm-dd') : '--'
            }}</span>
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_3 col-0">
              {{ file.uploader }}
            </span>
            <!-- <a v-if="userInservice" class="propject_detail_info_table_cell propject_detail_info_files_cell_4 col-0" @click="download(file)"
              >下载</a
            > -->
          </div>
        </div>
      </el-card>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" :modal="false" @closed="onCancel">
      <div v-if="dialogTitle === '参与成员'">
        <div class="flex-row mb5">
          <div class="col-0 propject_detail_info_label mr5">客户开发</div>
          <div class="col-1 flex-row flex-wrap flex_wrap_container">
            <div v-for="(item, index) in changes['客户开发']" :key="index" class="flex_wrap_item">
              <el-select v-model="changes['客户开发'][index]" filterable size="mini">
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner('客户开发', index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === changes['客户开发'].length - 1" class="col-0 mr5" @click="addPartner('客户开发')">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
          </div>
        </div>
        <div class="flex-row mb5">
          <div class="col-0 propject_detail_info_label mr5">项目对接</div>
          <div class="col-1 flex-row flex-wrap flex_wrap_container">
            <div v-for="(item, index) in changes['项目对接']" :key="index" class="flex_wrap_item">
              <el-select v-model="changes['项目对接'][index]" filterable size="mini">
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner('项目对接', index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === changes['项目对接'].length - 1" class="col-0 mr5" @click="addPartner('项目对接')">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
          </div>
        </div>
        <div class="flex-row mb5">
          <div class="col-0 propject_detail_info_label mr5">项目经理</div>
          <div class="col-1 flex-row flex-wrap flex_wrap_container">
            <div v-for="(item, index) in changes['项目经理']" :key="index" class="flex_wrap_item">
              <el-select v-model="changes['项目经理'][index]" filterable size="mini">
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner('项目经理', index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === changes['项目经理'].length - 1" class="col-0 mr5" @click="addPartner('项目经理')">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
          </div>
        </div>
        <div class="flex-row mb5">
          <div class="col-0 propject_detail_info_label mr5">项目成员</div>
          <div class="col-1 flex-row flex-wrap flex_wrap_container">
            <div v-for="(item, index) in changes['项目成员']" :key="index" class="flex_wrap_item">
              <el-select v-model="changes['项目成员'][index]" filterable size="mini">
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner('项目成员', index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === changes['项目成员'].length - 1" class="col-0 mr5" @click="addPartner('项目成员')">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="mr10">
          <el-button size="mini" type="danger" @click="dialogVisible = false">取 消</el-button>
        </span>
        <el-button size="mini" type="primary" @click="onConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 搜索人选弹窗 -->
    <serch-radish-dialog
      ref="serchRadishDialog"
      :could-insert="true"
      choose-btn-text="选择"
      :could-choose-more="true"
      @choose="chooseRadish"
      @chooseMore="chooseMoreRadish"
    ></serch-radish-dialog>
    <!-- 新增面试地址 -->
    <addCompanyAddress ref="addCompanyAddress" @addAddress="addAddress"></addCompanyAddress>
    <SelectCompany ref="SelectCompany" @confirm="addCompany"></SelectCompany>
  </div>
</template>

<script>
import TagShow from '../../../company/src/component/TagShow.vue'
import { download, preview, genPositionSpeech } from '../constant/utils'
import {
  professionalLevel,
  业绩,
  locations,
  tags,
  companyKeyWordLabel,
  projectStatus,
  professionalRank,
} from '../constant/type'
// import { serchRadishDialog } from '../../../company'
import serchRadishDialog from '../../../company/src/component/serchRadishDialog.vue'
import addCompanyAddress from '../../../company/src/dialog/addCompanyAddress'
import ProjectSteps from './projectProgress/ProjectSteps'
import SelectCompany from '../../../company/src/hunting/selectCompany'
import ProjectGrade from './ProjectGrade'

// 组件已弃用

const arrRemove = (arr, func) =>
  Array.isArray(arr)
    ? arr.filter(func).reduce((acc, val) => {
        arr.splice(arr.indexOf(val), 1)
        return acc.concat(val)
      }, [])
    : []

const dateFormat = require('dateformat')

const defaultProject = {
  标签: [],
  startTime: Date.now(),
  年龄要求: ['', ''],
  年薪范围: ['', ''],
  月薪范围: ['', ''],
  工作年限: ['', ''],
  优先级: 1,
  项目状态: '进展中',
  办公地: [],
  面试地址: [],
}
export default {
  components: { TagShow, serchRadishDialog, addCompanyAddress, ProjectSteps, SelectCompany, ProjectGrade },
  props: {
    projectHrids: { type: Array, default: () => [] },
    changeFields: { type: Array, default: () => [] },
    updateProject: { type: Function, default: () => {} },
    cancelEdit: { type: Function, default: () => {} },
    addProjectLeader: { type: Function, default: () => {} },
    showAddCompanyLeaderDialog: { type: Function, default: () => {} },
    project: { type: Object, default: () => ({}) },
    editProjectField: { type: Function, default: () => {} },
    upload: { type: Function, default: () => {} },
    changes: { type: Object, default: () => ({}) },
    company: { type: Object, default: () => ({}) },
    companyEditing: { type: Boolean, default: false },
    files: { type: Array, default: () => [] },
    portraitEditing: { type: Boolean, default: false },
    newAddProjectEditing: { type: Boolean, default: false },
    companyCollapsed: { type: Boolean, default: false },
    leadersEditing: { type: Boolean, default: false },
    editPortraitToggle: { type: Function, default: () => {} },
    editNewProjectToggle: { type: Function, default: () => {} },
    removeQuestion: { type: Function, default: () => {} },
    addQuestion: { type: Function, default: () => {} },
    saveNewProjectEdit: { type: Function, default: () => {} },
    editLeadersToggle: { type: Function, default: () => {} },
    editCompanyToggle: { type: Function, default: () => {} },
    // insertCompanyHr: { type: Function, default: () => {} },
    insertCompanyHrVisible: { type: Boolean, default: false },
    addProjectHR: { type: Function, default: () => {} },
    // addHr: { type: Function, default: () => {} },
    // addHrAndRadish: { type: Function, default: () => {} },
    removeProjectHr: { type: Function, default: () => {} },
    saveCompany: { type: Function, default: () => {} },
    // interviewRemarkInput: { type: Function, default: () => {} },
    // addInterviewAddr: { type: Function, default: () => {} },
    interviewAddrInput: { type: String, default: '' },
    // interviewRemarkInput: { type: String, default: '' },
    // removeInterviewAddr: { type: Function, default: () => {} },
    saveLeaders: { type: Function, default: () => {} },
    showDialog: { type: Function, default: () => {} },
    removeProjectLeader: { type: Function, default: () => {} },
    savePortraitEdit: { type: Function, default: () => {} },
    categoryObj: { type: Object, default: () => ({}) },
    showCompany: { type: Function, default: () => {} },
    editProjectTargetRadishes: { type: Function, default: () => {} },
    addProjectTag: { type: Function, default: () => {} },
    getTemporaryHrs: { type: Function, default: () => {} },
    getInterviewer: { type: Function, default: () => {} },
    chooseNewRadish: { type: Function, default: () => {} },
    interviewer: { type: Array, default: () => [] },
    addInterviewer: { type: Function, default: () => {} },
    editProjectFields: { type: Function, default: () => {} },
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: undefined,
      companyHRVisible: false,
      companyLeadersVisible: false,
      tagInputVisible: false,
      tagInput: '',
      companyHr: [],
      projectHRs: [],
      deletePeddingArr: [],
      temporaryHr: [],
      showInfoDetail: true,
      showDepartmentDetail: false,
      youxianji: ['低', '低', '中', '高', '高'],
      isHidden: {
        岗位要求: false,
        岗位职责: false,
        核心要求: false,
        职位亮点及优势: false,
        寻访方向: false,
        可能的问题及应对: false,
        项目话术: false,
      },
      isHiddenBtnShow: {
        岗位要求: false,
        岗位职责: false,
        核心要求: false,
        寻访方向: false,
        可能的问题及应对: false,
        项目话术: false,
      },
      infoIsEditing: false,
      departmentIsEditing: false,
      HightLightIsEditing: false,
      addCompanyVisible: false,
      companyAddressVisible: false,
      companyPendding: false,
      showNewComBtn: false,
      companyIndustry: '',
      companyFullname: '',
      companyShortname: '',
      errors: {},
      infoInEdit: window._.cloneDeep(defaultProject),
      remark: '',
      xunfangIsEditing: false,
      finalRadishes: [],
      // 是否在职，在职true
      userInservice: true,
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
    download() {
      return download
    },
    genPositionSpeech() {
      return genPositionSpeech
    },
    // async projectHRs() {
    //   if (!this.company._id) return []
    //   const val =  await this.getCompanyHrsByIds(this.project['对接hr'] || [])
    //   console.log(val);
    //   return val
    // },
    companyKeyWordLabel() {
      return companyKeyWordLabel
    },
    projectLeaders() {
      if (!this.company._id) return []
      const leaderIds = this.project.leaderIds || []
      return (this.company['领导'] || []).filter(leader => leaderIds.includes(leader._id))
    },
    professionalLevel() {
      return professionalLevel
    },
    业绩options() {
      return 业绩
    },
    projectStatus() {
      return projectStatus
    },
    professionalRank() {
      return professionalRank
    },
    industry() {
      return app.industries || []
    },
    locations() {
      return locations
    },
    细分职能options() {
      return this.categoryObj['二级职能'] || []
    },
    擅长方向options() {
      return this.categoryObj['擅长方向'] || []
    },
    tags() {
      return tags
    },
    categories() {
      return window.app.categories || []
    },
    categoryOptions() {
      return this.categories.map(category => ({
        label: category['名称'],
        value: category['名称'],
      }))
    },
    preview() {
      return preview
    },
  },
  watch: {
    async projectHrids(newValue, oldValue) {
      this.projectHRs = await this.getCompanyHrsByIds(newValue || [])
    },
    project: {
      async handler(value, oldValue) {
        if (value) {
          this.getInterviewer()
          this.getTemporaryHrs()
          this.getFinalRadishes()
          const category = value['职能模块']
          const clientCompany = value['客户公司'] && value['客户公司'].trim()
          if (clientCompany) {
            // TODO abort上一条pendding请求
            if (this.oldCompanyName === clientCompany) {
              return
            }
            this.oldCompanyName = clientCompany

            this.updateProjectCompany(value)
            const res = await window.app.service('company').duplicate({ 简称: clientCompany })
            if (res === '重复') {
              this.showNewComBtn = true
            } else {
              this.companyShortname = clientCompany
              this.showNewComBtn = false
            }
          } else {
            this.showNewComBtn = true
          }

          this.setHiddenStatus()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
    if (!app.categories) {
      await app.getCats()
    }
  },
  methods: {
    async getFinalRadishes() {
      const ids = this.project.finalRadishIds || []
      if (ids.length === 0) return (this.finalRadishes = [])
      this.finalRadishes = await this.getRadishesByIds(ids)
    },
    async getRadishesByIds(ids) {
      const res = await app.service('radish').simpleList({
        query: { _id: { $in: ids } },
        fields: { 姓名: 1 },
      })
      return res.status === 'success' ? res.data : []
    },
    showRadish(rid) {
      if (!rid) return
      window.open(`${window.frontend}/#/radish-detail-blank/${rid}`, '_blank')
    },
    addAddress2Project(item) {
      if (!this.project['面试地址']) {
        this.project['面试地址'] = [item]
        this.updateProject({ 面试地址: this.project.面试地址 })
      } else if (this.project['面试地址'].every(val => val._id !== item._id)) {
        this.project['面试地址'].push(item)
        this.companyAddressVisible = false
        this.updateProject({ 面试地址: this.project.面试地址 })
      }
    },
    toCompanyDetail() {
      window.open(`#/company/${this.company._id}`)
    },
    setHiddenStatus(type) {
      if (type) {
        this.isHidden[type] = false
        this.$nextTick(() => {
          this.isHiddenBtnShow[type] = this.$refs[type].offsetHeight > 48
          this.isHidden[type] = true
        })
      } else {
        for (const i in this.isHiddenBtnShow) {
          if (!this.$refs[i]) {
            break
          }
          this.isHiddenBtnShow[i] = this.$refs[i].offsetHeight > 48
          this.isHidden[i] = true
        }
      }
    },
    updateProjectInner(data) {
      this.updateProject(data, () => {
        this.$nextTick(() => {
          this.setHiddenStatus(data)
        })
      })
    },
    saveRemark() {
      const remark = this.project.remark || []
      remark.unshift({
        createAt: new Date().getTime(),
        user: app.user.account,
        remark: this.remark,
      })
      this.updateProject({ remark })
      this.remark = ''
    },
    toggleHide(key) {
      this.isHidden[key] = !this.isHidden[key]
    },
    async updateProjectCompany(value) {
      const res = await app.service('company').getCompany(value['客户公司'])
      if (res.status == 200) {
        const { tags, 用人偏好: companyTag, 公司备注: alphaCognize } = res.result
        if (alphaCognize) this.project['阿尔法认知'] = alphaCognize
        if (res.result['特殊要求']) this.project['客户特殊要求'] = res.result['特殊要求']
        if (!tags || typeof tags !== 'object' || Object.keys(tags).length === 0) return
        for (const type in tags) {
          tags[type].forEach(tag => {
            if (!this.project['标签'].includes(tag)) this.project['标签'].push(tag)
          })
        }
        if (companyTag && companyTag['语言能力']) {
          companyTag['语言能力'].forEach(tag => {
            if (!this.project['标签'].includes(tag)) this.project['标签'].push(tag)
          })
        }
      }
    },
    editXunfang() {
      this.xunfangIsEditing = true
      const fields = ['寻访方向', '目标公司备注', '不倾向公司备注', '目标人选备注', '阿尔法认知']
      this.editProjectFields(fields)
    },
    saveXunfang() {
      this.xunfangIsEditing = false
      // this.updateProjectInner(this.changes)
      this.updateProject(this.changes, () => {
        this.$nextTick(() => {
          this.setHiddenStatus('寻访方向')
        })
      })
    },
    cancelXunfang() {
      this.xunfangIsEditing = false
      this.cancelEdit(this.changes)
    },
    editDepartment() {
      this.departmentIsEditing = true
      // this.editProjectField('面试地址')
      // this.editProjectField('部门详情')
      this.editCompanyToggle()
      this.editLeadersToggle()
      this.editNewProjectToggle()
    },
    saveDepartment() {
      this.departmentIsEditing = false
      // this.updateProject({ 面试地址: this.project.面试地址 })
      // this.updateProject('部门详情')
      this.saveCompany()
      this.saveLeaders()
      this.saveNewProjectEdit()
    },
    cancelDepartment() {
      this.departmentIsEditing = false
      // this.cancelEdit('面试地址')
      this.cancelEdit('部门详情')
      this.editCompanyToggle()
      this.editLeadersToggle()
      this.editNewProjectToggle()
    },
    editHightLight() {
      this.HightLightIsEditing = true
      this.editProjectFields(['公司亮点及优势', '项目亮点及优势', '职位劣势及风险点'])
    },
    saveHightLight() {
      this.HightLightIsEditing = false
      this.updateProject({
        公司亮点及优势: this.changes['公司亮点及优势'] || null,
        项目亮点及优势: this.changes['项目亮点及优势'] || null,
        职位劣势及风险点: this.changes['职位劣势及风险点'] || null,
      })
    },
    cancelHightLight() {
      this.HightLightIsEditing = false
      this.cancelEdit({ 公司亮点及优势: true, 项目亮点及优势: true, 职位劣势及风险点: true })
    },
    formatRange(arr, str) {
      if (!arr || arr.length === 0 || (!arr[0] && !arr[1])) {
        return '--'
      } else if (arr.length === 1) {
        return `${arr[0]}${str}以上`
      } else if (!arr[0]) {
        return `${arr[1]}${str}以下`
      } else if (!arr[1]) {
        return `${arr[0]}${str}以上`
      } else {
        return `${arr[0]}-${arr[1]}${str}`
      }
    },
    removeTemporaryHr(hr) {
      const index = this.temporaryHr.findIndex(_hrid => _hrid === hr._id)
      const idIndex = this.project['项目对接hr'].findIndex(_hrid => _hrid === hr._id)
      if (index === -1) return
      this.project['项目对接hr'].splice(idIndex, 1)
      this.temporaryHr.splice(index, 1)
    },
    drop(event, index) {
      const temp = this.changes['标签'][index]
      const tomoveTag = this.changes['标签'][this.movetagindex]
      this.changes['标签'].splice(index, 1, tomoveTag)
      this.changes['标签'].splice(this.movetagindex, 1, temp)
    },
    allowDrop(event, index) {
      event.preventDefault()
    },
    drag(index) {
      this.movetagindex = index
    },
    dragtagclose(tag, tagindex) {
      this.changes['标签'].splice(tagindex, 1)
    },
    // 面试地址
    async removeCompanyAddress(_id) {
      this.project['面试地址'] = this.project['面试地址'].filter(ele => ele._id !== _id)
      this.updateProject({ 面试地址: this.project.面试地址 })
    },
    toAddAddress() {
      this.$refs.addCompanyAddress.open()
    },
    async addAddress(obj) {
      obj.cid = this.company._id
      try {
        const res = await app.service('company').addCompanyAddress(obj)
        if (res.status === 'success') this.company['面试地址'] = res.data
        this.$message.success(`操作成功`)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    //
    async insertCompanyHr() {
      let defaultSearchRadishes = []
      const res = await app.service('company').defaultSearchHrs(this.company.简称)
      if (res.status == 'success') defaultSearchRadishes = res.data
      else this.$message.error(res.msg)
      this.$refs.serchRadishDialog.open({ 公司: this.company.简称 }, defaultSearchRadishes)
      this.$el.click()
    },
    chooseMoreRadish(radishes) {
      for (const radish of radishes) {
        this.chooseRadish(radish)
      }
    },
    chooseRadish(radish) {
      const couldInsert = this.checkDuplicateHr(radish)
      if (couldInsert) this.addCompanyHr(radish)
      else this.$message.warning('该人选已添加，请勿重复操作')
    },
    checkDuplicateHr(radish) {
      const result = this.company.对接hr.find(hr => hr.rid === radish._id)
      return !result
    },
    async addCompanyHr(radish) {
      const leader = { rid: radish._id, cid: this.company._id }
      try {
        const res = await app.service('company').addCompanyHr(leader)
        if (res.status === 'success') {
          if (!this.company['对接hr']) this.company['对接hr'] = []
          const hr = {
            _id: res.data._id,
            rid: radish._id,
            cid: res.data.cid,
            姓名: radish.姓名,
            目前职位: radish.目前职位,
            职级: radish.职级,
            手机: radish.手机,
            座机: radish.座机,
            邮箱: radish.邮箱,
          }
          this.company['对接hr'].push(hr)
          this.addProjectHR(hr)
          this.$message.success(`操作成功`)
        } else {
          this.$message.error(res.msg)
        }
      } catch (e) {
        this.$message.error(e)
      }
    },
    async getCompanyHrsByIds(hrids) {
      const res = await app.service('company').getCompanyHrsByIds(hrids || [])
      return res.status === 'success' ? res.data : []
    },
    showRadishDetail(radish) {
      if (!radish || !radish._id) {
        this.$message('未找到人选')
        return
      }
      window.open(`${window.frontend}/#/radish-detail-blank/${radish._id}`, '_blank')
    },
    beforeUpload() {
      this.showDialog('附件类型')
    },
    selectCompany() {
      this.companyField = '目标公司'
      this.$refs.SelectCompany.open()
      // window.app.root.$refs.targetCompany.show({
      //   defaultCompanies: this.project['目标公司'] || [],
      //   onConfirm: value => {
      //     this.updateProject({ 目标公司: value })
      //   },
      // })
    },
    selectCompany1() {
      this.companyField = '不倾向公司'
      this.$refs.SelectCompany.open()
      // window.app.root.$refs.targetCompany.show({
      //   defaultCompanies: this.project['不倾向公司'] || [],
      //   onConfirm: value => {
      //     this.updateProject({ 不倾向公司: value })
      //   },
      // })
    },
    addCompany(value) {
      if (this.companyField) this.updateProject({ [this.companyField]: value })
    },
    handleInputConfirm() {
      if (this.tagInput) this.addProjectTag(this.tagInput)
      this.tagInputVisible = false
      this.tagInput = ''
    },
    showInput() {
      this.tagInputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput && this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    searchCategory(queryString, cb, options) {
      const results = queryString
        ? options.filter(val => val.label && val.label.toLowerCase().includes(queryString.toLowerCase()))
        : options
      cb(results)
    },
    editPartners() {
      const project = this.project
      const fields = ['客户开发', '项目对接', '项目经理', '项目成员']
      fields.forEach(field => {
        const value = (project[field] && project[field].slice()) || ['']
        this.$set(this.changes, field, value)
        if (this.changes[field].length === 0) this.changes[field].push('')
      })
      this.showDialog('参与成员')
    },

    addPartner(field) {
      const value = this.changes[field] || []
      const length = value.length
      if (length === 0 || value[length - 1]) {
        value.push('')
      }
      this.changes = Object.assign({}, this.changes, { [field]: value })
    },
    removePartner(field, index) {
      const value = this.changes[field] || []
      value.splice(index, 1)
      if (value.length === 0) value.push('')
      this.changes = Object.assign({}, this.changes, { [field]: value })
    },
    onCancel() {
      this.dialogVisible = false
      const dialogTitle = this.dialogTitle
      if (dialogTitle === '参与成员') {
        this.cancelEdit({
          客户开发: true,
          项目对接: true,
          项目经理: true,
          项目成员: true,
        })
      }
    },
    onConfirm() {
      const { changes, dialogTitle } = this
      if (dialogTitle === '参与成员') {
        this.updateProject({
          客户开发: (changes['客户开发'] && changes['客户开发'].filter(Boolean)) || [],
          项目对接: (changes['项目对接'] && changes['项目对接'].filter(Boolean)) || [],
          项目经理: (changes['项目经理'] && changes['项目经理'].filter(Boolean)) || [],
          项目成员: (changes['项目成员'] && changes['项目成员'].filter(Boolean)) || [],
        })
      }
      this.dialogVisible = false
    },
    editInfo() {
      this.infoIsEditing = true
      const fields = [
        '客户公司',
        '部门',
        '项目名称',
        'startTime',
        'guaranteeTime',
        'indroduceTime',
        '项目状态',
        '专业职级',
        '管理职级',
        '招聘数量',
        '优先级',
        '独家',
      ]
      const arrFields = ['办公地', '年龄要求', '工作年限', '年薪范围', '月薪范围']

      const obj = {}
      fields.forEach(field => {
        obj[field] = this.project[field] || ''
      })
      arrFields.forEach(field => {
        obj[field] = window._.cloneDeep(this.project[field] || [])
      })

      this.infoInEdit = obj
    },
    cancelInfo() {
      this.infoIsEditing = false
    },
    saveInfo() {
      this.infoIsEditing = false
      this.updateProject(this.infoInEdit)
    },
    async searchCompany(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      try {
        const { data } = await window.app.service('company').serchCompany(queryString)
        cb(
          data.map(company => ({
            label: company['简称'],
            value: company['简称'],
          })),
        )
      } catch (e) {
        console.error(e)
      }
    },
    async searchCompanyFullname(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      try {
        const { data, status } = await window.app.service('company').fuzzySearch({ name: queryString })
        if (status !== '200') {
          cb()
        }
        cb(
          data.map(company => ({
            label: company.Name,
            value: company.Name,
          })),
        )
      } catch (e) {
        console.error(e)
      }
    },
    async createCompany() {
      if (!this.companyFullname) {
        this.errors = Object.assign({}, this.errors, { 公司全称: true })
        return
      }
      if (!this.companyIndustry) {
        this.errors = Object.assign({}, this.errors, { 行业: true })
        return
      }
      if (this.companyPendding) return
      this.companyPendding = true
      try {
        const res = await window.app.service('company').insertCompany({
          company: {
            简称: this.companyShortname,
            公司名称: this.companyFullname,
            行业: this.companyIndustry,
          },
        })
        if (res.status == 200) {
          this.$message('新建公司成功')
          this.showNewComBtn = true
          this.addCompanyVisible = false
        } else {
          this.$message.error(res.msg)
        }
      } catch (e) {
        this.$message.error(e.message)
      }
      this.companyPendding = false
    },
  },
}
</script>
<style scoped>
pre {
  white-space: pre-wrap;
}
pre.hidden {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.el-textarea__inner {
  font-size: 14px;
}
div.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 10px 0;
  position: absolute;
  width: 100%;
  top: 0;
  right: 0;
  z-index: 10;
}
div.title .name {
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
div.title .name i {
  font-size: 32px;
  margin-right: 10px;
}
div.title .handel-btn {
  font-size: 14px;
  color: #409eff;
  display: flex;
  align-items: center;
}
.content {
  font-size: 14px;
}
.content .el-row {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.project_detail_box {
  display: flex;
  flex-wrap: wrap;
}
.project_detail_item {
  margin-right: 30px;
  margin-bottom: 10px;
  white-space: pre-wrap;
  word-break: break-word;
  max-width: 100%;
  display: flex;
  align-items: baseline;
}
.project_detail_item b {
  word-break: keep-all;
  align-self: baseline;
}
.label_tag {
  white-space: nowrap;
  margin-top: 0;
  margin-bottom: 5px;
}
</style>
